var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsTabMoreInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.5 26)",
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#828284",
    x: 48,
    y: 2,
    width: 18,
    height: 18,
    rx: 3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AAAAAC",
    cx: 9,
    cy: 11,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.414 3.414 13.172 13.172A2 2 0 0 1 39.172 20H26a2 2 0 0 1-2-2V4.828a2 2 0 0 1 3.414-1.414z",
    fill: "#505052"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsTabMoreInactive);
export default __webpack_public_path__ + "static/media/icons_tab_more_inactive.91893807ee77fdb3aa7d1549ea4570bb.svg";
export { ForwardRef as ReactComponent };